<div class="paypal-box h-100">
  <div class="d-flex flex-wrap h-100">
    <div class=" col-12 col-md-6 col-sm-12 bg-color">
      <div class="paypal-box-left sticky d-flex justify-content-center align-items-center flex-column">
        <img class="box-img"
             [src]="ub.buildCourseThumbnailUrl(data.course)"/>
        <div class="course-title">
          <h2>{{data.course.title}}</h2>
        </div>
        <div class="course-include">
          <h4>{{ 'course.thisCourseIncludes' | translate }}</h4>

          <ul>
            <li *ngIf="data.course?.totalDuration && !data?.course?.hideDuration">
              <span class="material-symbols-outlined"> schedule </span>
              <p>{{
                "course.totalDuration" | translate: {
                  totalDuration:
                    data.course.totalDuration
                      | duration : "hours"
                }
                }}</p>
            </li>
            <li *ngIf="!data?.course?.lifetimeOfferTextOff">
              <span class="material-symbols-outlined"> all_inclusive </span>
              <p>{{ "course.fullLifeTimeAccess" | translate }}</p>
            </li>
            <li>
              <span class="material-symbols-outlined"> tv </span>
              <p>{{ "course.accessOnMobileAndTV" | translate }}</p>
            </li>
            <li *ngIf="!data?.course?.certificate?.disabled">
              <span class="material-symbols-outlined"> verified </span>
              <p>{{ "course.certificateOfCompletion" | translate }}</p>
            </li>
            <li *ngIf="data.captionsList">
              <span class="material-symbols-outlined"> volume_up </span>
              <p>{{data.captionsList}}</p>
            </li>
            <li *ngIf="data.totalArticles">
              <span class="material-symbols-outlined">article</span>
              <p>
                {{
                "course.totalArticles"
                  | translate : {totalArticles: data.totalArticles}
                }}
              </p>
            </li>
          </ul>
        </div>
        <div class="money-back d-flex flex-column align-items-center" *ngIf="data?.tenant?.guaranteeOffered">
          <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/shield%20(1).svg" alt=""/>
          <span>{{
            "course.guaranteeDays"
              | translate
              : {guaranteeDays: data?.tenant?.guaranteeDays}
            }}</span>
        </div>
      </div>
    </div>
    <div class=" col-12 col-md-6 col-sm-12">
      <div class="paypal-box-right d-flex justify-content-center flex-column">
        <div id="paypal-button" class="paypal-button"></div>
        <mat-spinner class="spinner" *ngIf="!buttonsInitialized"></mat-spinner>
      </div>
    </div>
    <button class="btn-close" (click)="onClose()">
      <span class="material-symbols-outlined"> close </span>
    </button>
  </div>
</div>
